import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { getHyphenatedPhoneNumber } from '../../../utils/general';
export const ResendMultiInviteModal = ({ hideModal, onResendMultiInvites, isLoading, pendingT2CAuthPhoneNumbers, }) => {
    const isPlural = pendingT2CAuthPhoneNumbers.length > 1;
    const ending = (plural) => {
        return plural ? 's' : '';
    };
    const headerText = `Resend Text2Confirm Invite${ending(isPlural)}`;
    const bodyText = `A text message will be sent to the number${ending(isPlural)} below. The user${ending(isPlural)} must reply to the text message to confirm Text2Confirm enrollment.`;
    const resendBtnText = `Resend Invite${ending(isPlural)}`;
    const formattedT2CNumbers = pendingT2CAuthPhoneNumbers
        .map((number) => {
        return getHyphenatedPhoneNumber(number);
    })
        .join(', ');
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal },
            React.createElement("span", { "data-testid": "header-element" }, headerText)),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", "data-testid": "body-element" }, bodyText),
            React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, { variant: "body-base", weight: "bold", "data-qm-mask": "", "data-testid": "phone-element" }, formattedT2CNumbers))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "Cancel"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onResendMultiInvites, "data-testid": "resend-multi-invites-btn" }, resendBtnText)))));
};
ResendMultiInviteModal.displayName = 'ResendMultiInviteModal';
